export class User {
  constructor(fields?: Partial<User>) {
    Object.assign(this, fields);
  }

  Id: number;
  Email: string;
  Username: string;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Company: string;
  FullName: string;
  Phone: string;
  DateOfBirth?: Date;
  Active: boolean;
  CreatedOn: Date;
  LastActivityDate: Date;
  StudentId: string;
  Roles: string[];
  Role: string;
  RoleId: number;
  ExistingPassword: string;
  NewPassword: string;
  PasswordSalt: string;
  GridStateData: string;
  HasPayPerEnrollmentSchool: boolean;
  IsDefaultCounselor?: boolean;
  GuardianFirstName: string;
  GuardianMiddleName: string;
  GuardianLastName: string;
  GuardianEmail: string;
  GuardianPhone: string;
  Grade?: number;
  Gender: string;
  Address1: string;
  Address2: string;
  City: string;
  StateProvinceId?: number;
  CountryId?: number;
  StateName: string;
  Zip: string;
  AffiliateId?: number;
  AffiliateType?: any;
  IsImpersonated: boolean;
  HasCourseInstances?: boolean;
}
